import { render, staticRenderFns } from "./tolov.vue?vue&type=template&id=490668c4&"
import script from "./tolov.vue?vue&type=script&lang=js&"
export * from "./tolov.vue?vue&type=script&lang=js&"
import style0 from "./tolov.vue?vue&type=style&index=0&id=490668c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports